import { render, staticRenderFns } from "./middlePage.vue?vue&type=template&id=e0df7234&"
import script from "./middlePage.vue?vue&type=script&lang=js&"
export * from "./middlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports